// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scheduleContainer {
  padding: 1.25rem 1rem 0.5rem;
}
.scheduleContainer .title {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin: 0 0 0.75rem;
  font-size: 1rem;
  font-weight: 700;
  text-align: left;
  color: #333;
}
.scheduleContainer .dayList {
  background-color: #ffffff;
  border-radius: 1rem;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}
.scheduleContainer .dayList .scheduleItem {
  display: grid;
  grid-template-columns: 6.5rem 1fr;
  align-items: center;
  gap: 0.5rem;
  padding: 0.55rem 1rem;
  border-bottom: 1px solid rgba(80, 80, 80, 0.08);
}
.scheduleContainer .dayList .scheduleItem:last-child {
  border-bottom: none;
}
.scheduleContainer .dayList .scheduleItem .scheduleDay {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-weight: 600;
  font-size: 0.82rem;
  color: #222;
}
.scheduleContainer .dayList .scheduleItem .scheduleDay::before {
  content: "";
  flex-shrink: 0;
  width: 0.4rem;
  height: 0.4rem;
  background-color: #515592;
  border-radius: 50%;
}
.scheduleContainer .dayList .scheduleItem .scheduleTimes {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
}
.scheduleContainer .dayList .scheduleItem .scheduleTime {
  font-weight: 500;
  font-size: 0.75rem;
  color: #555;
  background-color: rgba(80, 80, 80, 0.06);
  padding: 0.15rem 0.5rem;
  border-radius: 10px;
  white-space: nowrap;
}
.scheduleContainer .dayList .dayOff {
  color: rgb(150, 150, 150);
}`, "",{"version":3,"sources":["webpack://./src/components/WorkHours/WorkHours.scss","webpack://./src/assets/Theme/variables/_colorSchema.scss"],"names":[],"mappings":"AAIA;EACE,4BAAA;AAHF;AAKE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;AAHJ;AAME;EACE,yBCnBI;EDoBJ,mBAAA;EACA,0CAAA;EACA,gBAAA;AAJJ;AAMI;EACE,aAAA;EACA,iCAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;EACA,+CAAA;AAJN;AAMM;EACE,mBAAA;AAJR;AAOM;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;AALR;AAOQ;EACE,WAAA;EACA,cAAA;EACA,aAAA;EACA,cAAA;EACA,yBA/CM;EAgDN,kBAAA;AALV;AASM;EACE,aAAA;EACA,eAAA;EACA,YAAA;AAPR;AAUM;EACE,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,wCAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AARR;AAYI;EACE,yBClEO;ADwDb","sourcesContent":["@import '../../assets/Theme/variables/colorSchema';\n\n$brand_primary: #515592;\n\n.scheduleContainer {\n  padding: 1.25rem 1rem 0.5rem;\n\n  .title {\n    display: flex;\n    align-items: center;\n    gap: 0.4rem;\n    margin: 0 0 0.75rem;\n    font-size: 1rem;\n    font-weight: 700;\n    text-align: left;\n    color: #333;\n  }\n\n  .dayList {\n    background-color: $white;\n    border-radius: 1rem;\n    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.05);\n    overflow: hidden;\n\n    .scheduleItem {\n      display: grid;\n      grid-template-columns: 6.5rem 1fr;\n      align-items: center;\n      gap: 0.5rem;\n      padding: 0.55rem 1rem;\n      border-bottom: 1px solid rgba($unselectedText, 0.08);\n\n      &:last-child {\n        border-bottom: none;\n      }\n\n      .scheduleDay {\n        display: flex;\n        align-items: center;\n        gap: 0.4rem;\n        font-weight: 600;\n        font-size: 0.82rem;\n        color: #222;\n\n        &::before {\n          content: '';\n          flex-shrink: 0;\n          width: 0.4rem;\n          height: 0.4rem;\n          background-color: $brand_primary;\n          border-radius: 50%;\n        }\n      }\n\n      .scheduleTimes {\n        display: flex;\n        flex-wrap: wrap;\n        gap: 0.35rem;\n      }\n\n      .scheduleTime {\n        font-weight: 500;\n        font-size: 0.75rem;\n        color: #555;\n        background-color: rgba($unselectedText, 0.06);\n        padding: 0.15rem 0.5rem;\n        border-radius: 10px;\n        white-space: nowrap;\n      }\n    }\n\n    .dayOff {\n      color: $msgDisable;\n    }\n  }\n}\n","$white: #ffffff;\n$text_dark: #2c2c2e;\n$text_gray: rgb(178, 181, 188);\n$buttonBg: #363c56;\n$errorText: #f70d1a;\n$buttonLinearBg: linear-gradient(to right, #1d2239, #4657a2, #1d2239);\n$msgDisable: rgb(150, 150, 150);\n$disabled: rgb(200, 200, 200);\n$light_gray: rgb(241, 241, 241);\n$unselectedText: rgb(80, 80, 80);\n$locationBnt: rgb(255, 255, 0);\n$spinner_blue: #3498db;\n\n$bg_unselected: rgb(188, 188, 224);\n$bg_selected: #559f5b;\n$bg_pending: #ccb137;\n$bg_frame: rgba(0, 0, 0, 0.6);\n\n$shadow: #2c2c2e5e;\n$light_shadow: rgba(49, 49, 52, 0.2);\n$highlighter: #eeff6e;\n$appt_bg: rgb(249, 249, 249);\n$red_bg: #cb101a;\n\n$notification_success: #4fae00;\n$notification_warning: #e4dd00;\n$notification_error: #be1000;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
